import React, { Component } from 'react';
import WreckAPI from '../lib/wreck_api.js';
import JoinForm from '../components/join_form.js';

class Join extends Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    const accountData = {
      email: formData.get('email'),
      info: {
        prefered_sport: formData.get('sportPreference'),
        full_name: formData.get('name')
      }
    }

    WreckAPI.create_account(accountData)
      .then((data) => {
        console.log("Account Created")
      })
      .catch((data) => {
        console.error(data)
        alert(JSON.stringify(data.error))
      })
  }

  render() {
    const LayoutWrapper = this.props.layout

    return (
      <LayoutWrapper>
        <div className="page">
          <h2>Join free now and start viewing wrecks today</h2>
          <hr />
          <JoinForm handleSubmit={this.handleSubmit} />
        </div>
      </LayoutWrapper>
    );
  }
}

export default Join;



// WEBPACK FOOTER //
// ./src/pages/join.js